import type {GradientPalette} from '../types';
import {PALETTE_ID} from '../types';

export default {
    id: PALETTE_ID.TRAFFIC_LIGHT_9,
    scheme: [
        '#9C0125',
        '#F17A03',
        '#228782',
        '#C40802',
        '#FDA816',
        '#2EB887',
        '#ED4902',
        '#FDCE34',
        '#79DD8B',
    ],
    gradient: true,
} as GradientPalette;
